import {
  Box,
  Button,
  Card,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import StudentFeeDetails from '../pages/[admin]/Student/StudentFeeDetails';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { searchForStudent } from '../features/payments/PaymentSlice';
import CloseIcon from '@mui/icons-material/Close';

function PaymentsPage() {
  const dispatch = useDispatch();
  const [studentId, setStudentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [studentList, setStudentsList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  async function searchStudent() {
    setLoading(true);
    try {
      const response = await dispatch(searchForStudent(searchValue)).unwrap();
      if (response?.length > 1) {
        setStudentsList(response);
        setStudentId('');
      } else if (response?.length == 1) {
        setStudentId(response?.[0]?.studentId);
        setStudentsList([]);
      } else {
        setStudentId(searchValue);
        setStudentsList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box className='p-4'>
      {' '}
      <Box className='bg-blue-50 p-4 rounded-lg mb-4'>
        <Typography variant='h6' className='text-blue-700 font-bold'>
          Manage Payments
        </Typography>
        <Typography variant='body1' className='text-gray-600'>
          Search for student and manage student payments details here.
        </Typography>
      </Box>
      <Card className='max-w-5xl px-4 py-10 border'>
        <div className=' mb-4 ml-2'>
          <Typography variant='h6' className='mb-2'>
            Enter Student Id, Name, Mobile etc and manage payments detials.
          </Typography>
          <div className='flex items-center flex-wrap gap-2 mb-4 '>
            <TextField
              value={searchValue}
              id='studentId'
              size='small'
              className='w-80 mr-10'
              placeholder='StudentId, Name, Mobile etc ..'
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    {!!searchValue && (
                      <IconButton
                        onClick={() => {
                          setSearchValue('');
                          setStudentId('');
                        }}
                      >
                        <CloseIcon></CloseIcon>
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchValue(e.target.value)}
            ></TextField>

            <Button
              variant='contained'
              disabled={!searchValue || loading}
              onClick={searchStudent}
            >
              {loading ? 'Searching' : 'Search'}
            </Button>
          </div>
          {studentList?.length >= 2 && (
            <div>
              <TableContainer
                component={Paper}
                variant='outlined'
                sx={{
                  maxHeight: 400,
                  overflow: 'auto',
                }}
              >
                <Table stickyHeader size='small' sx={{ minWidth: 900 }}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                      <TableCell className='text-blue-600'>
                        <strong>SNO</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>Student Id</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>First Name</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>Last Name</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>Mobile</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>Class</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>Section</strong>
                      </TableCell>
                      <TableCell className='text-blue-600'>
                        <strong>Actions</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {studentList?.slice(0, 10)?.map((row, index) => (
                      <TableRow
                        key={row?.id || index}
                        hover
                        sx={{
                          '&:nth-of-type(odd)': {
                            backgroundColor: '#fafafa',
                          },
                        }}
                      >
                        {' '}
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row?.studentId}</TableCell>
                        <TableCell>{row?.firstName}</TableCell>
                        <TableCell>{row?.lastName}</TableCell>
                        <TableCell>{row?.mobileNumber}</TableCell>
                        <TableCell>{row?.departmentName}</TableCell>
                        <TableCell>{row?.className}</TableCell>
                        <TableCell>
                          {' '}
                          <Button
                            onClick={() => {
                              setSearchValue(row?.studentId);
                              setStudentId(row?.studentId);
                              setStudentsList([]);
                            }}
                          >
                            Manage Payments
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
        <StudentFeeDetails StudentId={studentId} />
      </Card>
    </Box>
  );
}
export default PaymentsPage;
